module.exports = __webpack_public_path__ + "img/2nd.0c6b060.png";